import { api } from '@/lib/api';
import type {
  CounterDueItem,
  CounterReading,
  LatestReadingsMap,
  RecordCounterReadingPayload,
  SupersedeCounterReadingPayload,
} from './types';

export interface ListReadingsParams {
  field?: string;
  from?: string;
  to?: string;
  limit?: number;
}

export const counterReadingsApi = {
  listForEquipment: async (
    equipmentId: string,
    params: ListReadingsParams = {},
  ): Promise<CounterReading[]> => {
    const { data } = await api.get<CounterReading[]>(
      `/equipment/${equipmentId}/counter-readings`,
      { params },
    );
    return data;
  },

  latestForEquipment: async (
    equipmentId: string,
  ): Promise<LatestReadingsMap> => {
    const { data } = await api.get<LatestReadingsMap>(
      `/equipment/${equipmentId}/counter-readings/latest`,
    );
    return data;
  },

  due: async (
    params: { vesselId?: string; companyId?: string } = {},
  ): Promise<CounterDueItem[]> => {
    const { data } = await api.get<CounterDueItem[]>(
      '/counter-readings/due',
      { params },
    );
    return data;
  },

  record: async (
    input: RecordCounterReadingPayload,
  ): Promise<CounterReading> => {
    const { data } = await api.post<CounterReading>(
      '/counter-readings',
      input,
    );
    return data;
  },

  supersede: async (
    readingId: string,
    input: SupersedeCounterReadingPayload,
  ): Promise<CounterReading> => {
    const { data } = await api.post<CounterReading>(
      `/counter-readings/${readingId}/supersede`,
      input,
    );
    return data;
  },
};
